import { useTheme } from "app/shared";
import { ReactComponent as XIcon } from "assets/img/icons/xDark.svg";
import { FC } from "react";
import styles from "./ProjectMemoHeader.module.scss";

interface ProjectHeaderProps {
  name: string;
  vertical: string;
  followers: string;
  pitchDeck?: string;
  website?: string;
  tokenomics?: string;
}

const ProjectMemoHeader: FC<ProjectHeaderProps> = ({
  name,
  vertical,
  followers,
  pitchDeck,
  tokenomics,
  website,
}) => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h2 className={styles.title}>PROJECT OVERVIEW</h2>
      <div className={styles.content}>
        <div className={styles.infoSection}>
          <div
            className={`${styles.infoCard} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
          >
            <div className={styles.cardHeader}>Name</div>
            <div className={styles.cardValue}>{name}</div>
          </div>
          <div
            className={`${styles.infoCard} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
          >
            <div className={styles.cardHeader}>Vertical</div>
            <div className={styles.cardValue}>{vertical}</div>
          </div>
          <div
            className={`${styles.infoCard} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
          >
            <div className={styles.cardHeader}>Social</div>
            <div className={styles.socialValue}>
              <XIcon className={styles.xIcon} />
              <span>{followers} followers</span>
            </div>
          </div>
        </div>
        <div className={styles.linksSection}>
          <div
            className={`${styles.linksCard} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
          >
            <div className={styles.cardHeader}>Links</div>
            <div className={styles.linksGroup}>
              {pitchDeck && (
                <a
                  href={pitchDeck}
                  target="_blank"
                  className={styles.linkButton}
                >
                  Pitch Deck
                </a>
              )}
              {tokenomics && (
                <a
                  href={tokenomics}
                  target="_blank"
                  className={styles.linkButton}
                >
                  Tokenomics
                </a>
              )}
              {website && (
                <a href={website} target="_blank" className={styles.linkButton}>
                  Website
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectMemoHeader;
